import _ from 'lodash';
import { createTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import * as locales from '@mui/material/locale';

import { useERACustomizer } from 'src/contexts/era-package/EraCustomizerContext';

import components from './Components';
import typography from './Typography';
import { shadows, darkshadows } from './Shadows';
import { DarkThemeColors } from './DarkThemeColors';
import { LightThemeColors } from './LightThemeColors';
import { baseDarkTheme, baselightTheme } from './DefaultColors';
import { useTheme } from '@material-ui/core';

export const BuildTheme = (config) => {
  const theme4 = useTheme()
  const themeOptions = LightThemeColors.find((theme) => theme.name === config.theme);
  const darkthemeOptions = DarkThemeColors.find((theme) => theme.name === config.theme);
  const customizer = useERACustomizer()
  const defaultTheme = customizer.activeMode === 'dark' ? baseDarkTheme : baselightTheme;
  const defaultShadow = customizer.activeMode === 'dark' ? darkshadows : shadows;
  const themeSelect = customizer.activeMode === 'dark' ? darkthemeOptions : themeOptions;
  const baseMode = {
    palette: {
      mode: customizer.activeMode,
    },
    shape: {
      borderRadius: customizer.borderRadius,
    },
    shadows: defaultShadow,
    typography: typography,
  };
  let theme = createTheme(
    _.merge({}, baseMode, defaultTheme, locales, themeSelect, {
      direction: config.direction,
    }),
  );
  // Integrate mui4 theme's palette
  if (theme4.hasOwnProperty('palette'))
    theme = createTheme(theme, { palette: theme4.palette })
  theme.components = components(theme);
  console.log('palette', theme)
  return theme;
};

const ThemeSettings = () => {
  const { activeDir, activeTheme } = useERACustomizer()
  const theme = BuildTheme({
    direction: activeDir,
    theme: activeTheme,
  });
  useEffect(() => {
    document.dir = activeDir;
  }, [activeDir]);

  return theme;
};


export { ThemeSettings };
